import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TNetService {
  public modalShow: boolean = false;

  constructor() {}

  setTnetCompaniesModal(data) {
    this.modalShow = data;
  }
}
